export function getElOrFalse(el: Element | null) {
    if (el instanceof HTMLElement) return el
    return false
}

export function getElOrThrow(el: Element | null) {
    if (el instanceof HTMLElement) return el
    throw new Error(`expected HTMLElement but got ${el}`)
}
